var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8147 4L24.8005 25.8168L16.0738 28.1665L7.34703 25.8168L5.33325 4H26.8147ZM22.756 8.43611H16.066H9.25747L9.58308 11.0707H16.066H16.4301L16.066 11.2223L9.82002 13.8237L10.0272 16.3989L16.066 16.4185L19.3026 16.4287L19.0954 19.8625L16.0659 20.7154V20.7127L16.0411 20.7196L13.1154 19.9811L12.9378 17.8496H12.9281H10.2144H10.2048L10.5601 21.9644L16.066 23.5926V23.5897L16.076 23.5926L21.5524 21.994L22.2628 13.8237H16.066H16.0508L16.066 13.817L22.4898 11.0707L22.756 8.43611Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.c74e0871cec184cb6feecbf89c24d399.svg";
export { ForwardRef as ReactComponent };